import React, { useMemo, useEffect } from 'react'
import { Form, Button, Input, Row, Col, Divider, Popconfirm } from 'antd'
import './style.less'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { QcType } from '@pages/task/quality-check-reexamine-detail/constant'
import { translateToDataValues, translateToFormValues } from '../utils'
const initialValue = {
  'name': '',
  'type': QcType.scenarioTag,
  'items': [
    {
      'moduleName': '',
      'name': '',
      'description': '',
    },
  ],
}

const CreateEditScenarioTag = ({ qcPlanDetail, qcId, onSave }: { qcPlanDetail: AIQualityCheckPlanDetailItem; qcId: number | null, onSave: (data: AIQualityCheckPlanDetailItem) => void }) => {
  const [form] = Form.useForm()
  useEffect(() => {
    if (qcId && qcPlanDetail) {
      form.setFieldsValue(translateToFormValues(qcPlanDetail))
    }
  }, [qcId, qcPlanDetail])
  const onFinish = (values) => {
    const newValues = translateToDataValues(values)
    onSave(newValues)
  }

  return (
    <div className="scheme-create-scenario-tag-form-container">
      <Form
        form={form}
        onFinish={onFinish}
        name="scenario-tag-form"
        initialValues={translateToFormValues(initialValue)} // 设置初始值
      >
        <Form.Item hidden label="方案ID" name="id">
          <Input />
        </Form.Item>
        <Form.Item label="方案类型" name="type" className="scenario-tag-form-primary-item">
          <Button type="dashed" size="small" style={{ borderColor: '#1890ff', color: '#1890ff' }}>
            #情绪标签
          </Button>
        </Form.Item>

        <Row style={{ width: '100%' }}>
          <Col span={10}>
            <Form.Item label="方案名称" name="name" rules={[{ required: true, message: '请输入方案名称' }]} className="scenario-tag-form-primary-item">
              <Input maxLength={20} placeholder="请输入方案名称" />
            </Form.Item>
          </Col>
        </Row>

        <Form.List name="nodeResults">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field) => (
                <div key={field.key}>
                  <div key={field.key}>
                    {/* 板块输入框和按钮放在同一行 */}
                    <Row style={{ width: '100%' }}>
                      <Col span={6}>
                        <Form.Item
                          className="scenario-tag-form-primary-item"
                          label="板块"
                          name={[field.name, 'moduleName']}
                          rules={[{ required: true, message: '请输入板块名称' }]}
                        >
                          <Input maxLength={10} placeholder="请输入板块名称" />
                        </Form.Item>
                      </Col>
                      <Col span={4}>
                        <Row>
                          <Col>
                            <Form.List name={[field.name, 'items']}>
                              {(innerFields, { add: addInner }) => (
                                <Form.Item>
                                  <Button
                                    type="primary"
                                    onClick={() => addInner({
                                      'name': '',
                                      'description': '',
                                    })}
                                    style={{ marginLeft: 8 }}
                                  >
                                    新建标签
                                  </Button>
                                </Form.Item>
                              )}
                            </Form.List>
                          </Col>
                          <Col>
                            {
                              fields.length > 1 && (
                                <Form.Item wrapperCol={{ span: 3 }}>
                                  <Popconfirm className="ml10" title="确认需要删除板块吗？" onConfirm={() => remove(field.name)}>
                                    <Button
                                      style={{ marginLeft: 8 }}
                                    >
                                      删除板块
                                    </Button>
                                  </Popconfirm>
                                </Form.Item>
                              )
                            }
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {/* 标签列表 */}
                    <Form.List name={[field.name, 'items']}>
                      {(innerFields, { remove: removeInner }) => (
                        <>
                          {innerFields.map((innerField, innerIndex) => (
                            <div key={innerField.key}>
                              <div className="scenario-tag-form-item-score" key={innerField.key}>
                                <Form.Item
                                  className="scenario-tag-form-primary-item"
                                  label={`标签${innerIndex + 1}`}
                                  name={[innerField.name, 'name']}
                                  rules={[{ required: true, message: '请输入标签名称' }]}
                                >
                                  <Input maxLength={100} placeholder="请填写标签名称，即需要模型去识别出的特征/行为/场景/情绪等" />
                                </Form.Item>
                                <Form.Item style={{ width: 50, textAlign: 'right' }}>
                                  {
                                    innerFields.length > 1 && (
                                      <Popconfirm title="确认需要删除标签吗？" onConfirm={() => removeInner(innerField.name)}>
                                        <Button
                                          type="link"
                                        >
                                          删除
                                        </Button>
                                      </Popconfirm>
                                    )
                                  }
                                </Form.Item>

                              </div>
                              <div className="scenario-tag-form-secondary-item">
                                <Form.Item colon={false} label={<span className="description-title">具体描述</span>} style={{ marginLeft: -10, width: '100%', marginBottom: 10 }} name={[innerField.name, 'description']} rules={[{ required: true, message: '请输入具体描述' }]}>
                                  <Input.TextArea maxLength={200} autoSize={{ minRows: 1, maxRows: 2 }} placeholder="请在此具体描述在什么场景下，可以为对话打上该标签，描述需要清晰具体，分点描述，描述越详细，模型效果越好" />
                                </Form.Item>
                                <div style={{ width: 55 }} />
                              </div>
                            </div>
                          ))}
                        </>
                      )}
                    </Form.List>
                  </div>
                  <Divider />
                </div>
              ))}

              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="primary"
                  onClick={() => add({
                    'moduleName': '',
                    'items': [
                      {
                        'name': '',
                        'description': '',
                      },
                    ],
                  })}
                >
                  新建板块
                </Button>
                <Form.Item style={{ marginLeft: 10 }}>
                  <Button type="primary" htmlType="submit">
                    保存方案
                  </Button>
                </Form.Item>
              </div>
            </>
          )}
        </Form.List>
      </Form>
    </div>
  )
}

export default CreateEditScenarioTag
